var _desc, _style, _rect, _g, _g2, _path, _text, _text2, _path2, _text3, _text4, _path3, _text5, _text6, _path4, _text7, _text8, _path5, _text9, _text10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 195,
    viewBox: "0 0 467 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, "Anurag Hazra's GitHub Stats, Rank: S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "descId"
  }, "Total Stars Earned: 54696, Total Commits in 2023 : 54696, Total PRs: 592, Total Issues: 134, Contributed to (last year): 6")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n          .header {\n            font: 600 18px 'Segoe UI', Ubuntu, Sans-Serif;\n            fill: #2f80ed;\n            animation: fadeInAnimation 0.8s ease-in-out forwards;\n          }\n          @supports(-moz-appearance: auto) {\n            /* Selector detects Firefox */\n            .header { font-size: 15.5px; }\n          }\n          \n    .stat {\n      font: 600 14px 'Segoe UI', Ubuntu, \"Helvetica Neue\", Sans-Serif; fill: #434d58;\n    }\n    @supports(-moz-appearance: auto) {\n      /* Selector detects Firefox */\n      .stat { font-size:12px; }\n    }\n    .stagger {\n      opacity: 0;\n      animation: fadeInAnimation 0.3s ease-in-out forwards;\n    }\n    .rank-text {\n      font: 800 24px 'Segoe UI', Ubuntu, Sans-Serif; fill: #434d58;\n      animation: scaleInAnimation 0.3s ease-in-out forwards;\n    }\n    \n    .not_bold { font-weight: 400 }\n    .bold { font-weight: 700 }\n    .icon {\n      fill: #4c71f2;\n      display: block;\n    }\n\n    .rank-circle-rim {\n      stroke: #2f80ed;\n      fill: none;\n      stroke-width: 6;\n      opacity: 0.2;\n    }\n    .rank-circle {\n      stroke: #2f80ed;\n      stroke-dasharray: 250;\n      fill: none;\n      stroke-width: 6;\n      stroke-linecap: round;\n      opacity: 0.8;\n      transform-origin: -10px 8px;\n      transform: rotate(-90deg);\n      animation: rankAnimation 1s forwards ease-in-out;\n    }\n    \n    @keyframes rankAnimation {\n      from {\n        stroke-dashoffset: 251.32741228718345;\n      }\n      to {\n        stroke-dashoffset: 6.054279203863718;\n      }\n    }\n  \n  \n\n          \n    /* Animations */\n    @keyframes scaleInAnimation {\n      from {\n        transform: translate(-5px, 5px) scale(0);\n      }\n      to {\n        transform: translate(-5px, 5px) scale(1);\n      }\n    }\n    @keyframes fadeInAnimation {\n      from {\n        opacity: 0;\n      }\n      to {\n        opacity: 1;\n      }\n    }\n  \n          \n        ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-testid": "card-bg",
    x: 0.5,
    y: 0.5,
    rx: 4.5,
    height: "99%",
    stroke: "#e4e2e2",
    width: 466,
    fill: "#fffefe",
    strokeOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-testid": "card-title",
    transform: "translate(25, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "header",
    "data-testid": "header"
  }, "Anurag Hazra's GitHub Stats")))), /*#__PURE__*/React.createElement("g", {
    "data-testid": "main-card-body",
    transform: "translate(0, 55)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-testid": "rank-circle",
    transform: "translate(390.5, 47.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rank-circle-rim",
    cx: -10,
    cy: 8,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    className: "rank-circle",
    cx: -10,
    cy: 8,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    className: "rank-text"
  }, /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 3,
    alignmentBaseline: "central",
    dominantBaseline: "central",
    textAnchor: "middle"
  }, "\n            S\n          ")))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stagger",
    style: {
      animationDelay: "450ms"
    },
    transform: "translate(25, 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "icon",
    className: "icon",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25zm0 2.445L6.615 5.5a.75.75 0 01-.564.41l-3.097.45 2.24 2.184a.75.75 0 01.216.664l-.528 3.084 2.769-1.456a.75.75 0 01.698 0l2.77 1.456-.53-3.084a.75.75 0 01.216-.664l2.24-2.183-3.096-.45a.75.75 0 01-.564-.41L8 2.694v.001z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 25,
    y: 12.5
  }, "Total Stars Earned:")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 219.01,
    y: 12.5,
    "data-testid": "stars"
  }, "54.7k")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stagger",
    style: {
      animationDelay: "600ms"
    },
    transform: "translate(25, 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "icon",
    className: "icon",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.643 3.143L.427 1.927A.25.25 0 000 2.104V5.75c0 .138.112.25.25.25h3.646a.25.25 0 00.177-.427L2.715 4.215a6.5 6.5 0 11-1.18 4.458.75.75 0 10-1.493.154 8.001 8.001 0 101.6-5.684zM7.75 4a.75.75 0 01.75.75v2.992l2.028.812a.75.75 0 01-.557 1.392l-2.5-1A.75.75 0 017 8.25v-3.5A.75.75 0 017.75 4z"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 25,
    y: 12.5
  }, "Total Commits (2023):")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 219.01,
    y: 12.5,
    "data-testid": "commits"
  }, "182")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 50)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stagger",
    style: {
      animationDelay: "750ms"
    },
    transform: "translate(25, 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "icon",
    className: "icon",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z"
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 25,
    y: 12.5
  }, "Total PRs:")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 219.01,
    y: 12.5,
    "data-testid": "prs"
  }, "592")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stagger",
    style: {
      animationDelay: "900ms"
    },
    transform: "translate(25, 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "icon",
    className: "icon",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 3a1 1 0 11-2 0 1 1 0 012 0zm-.25-6.25a.75.75 0 00-1.5 0v3.5a.75.75 0 001.5 0v-3.5z"
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 25,
    y: 12.5
  }, "Total Issues:")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 219.01,
    y: 12.5,
    "data-testid": "issues"
  }, "134")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 100)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stagger",
    style: {
      animationDelay: "1050ms"
    },
    transform: "translate(25, 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "icon",
    className: "icon",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"
  }))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 25,
    y: 12.5
  }, "Contributed to (last year):")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "stat  bold",
    x: 219.01,
    y: 12.5,
    "data-testid": "contribs"
  }, "6")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.a75ceb390a4570d3262ba2eb1f4ebdbc.svg";
export { ForwardRef as ReactComponent };